import { render, staticRenderFns } from "./PhoneScreenMain2.vue?vue&type=template&id=3d0ca23e&scoped=true&"
import script from "./PhoneScreenMain2.vue?vue&type=script&lang=js&"
export * from "./PhoneScreenMain2.vue?vue&type=script&lang=js&"
import style0 from "./PhoneScreenMain2.vue?vue&type=style&index=0&id=3d0ca23e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ca23e",
  null
  
)

export default component.exports